function startOfDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

// "Today at 9:41 AM" / "Yesterday at 2:30 PM" / "Monday at 11:00 AM" (rest of
// the current week) / "Jan 12" (older, same year) / "Jan 12, 2024" (other year).
export function formatRelativeDateTime(ts) {
  if (!ts) return "—";
  const d = new Date(ts);
  const now = new Date();
  const time = d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  const diffDays = Math.round((startOfDay(now) - startOfDay(d)) / 86400000);

  if (diffDays === 0) return `Today at ${time}`;
  if (diffDays === 1) return `Yesterday at ${time}`;
  if (diffDays > 1 && diffDays < 7) {
    return `${d.toLocaleDateString("en-US", { weekday: "long" })} at ${time}`;
  }

  const sameYear = d.getFullYear() === now.getFullYear();
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: sameYear ? undefined : "numeric" });
}
